import { Icon } from "@chakra-ui/react";
import React from "react";
import {
  getTwoToneChakraColors,
  TwoToneIconProps,
} from "./getTwoToneChakraColors";

export function SiLtfo({
  colorScheme = "primary",
  primaryShade = 600,
  secondaryShade = 200,
  ...props
}: TwoToneIconProps) {
  const { primaryColor, secondaryColor } = getTwoToneChakraColors({
    colorScheme,
    primaryShade,
    secondaryShade,
  });

  return (
    <Icon viewBox="0 0 32 32" fill="none" {...props}>
      <line
        x1="16"
        y1="20.8"
        x2="16"
        y2="5.8"
        stroke={secondaryColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M23 20L17.0278 26.0647C16.5192 26.5812 15.6881 26.5876 15.1716 26.0789L9 20"
        stroke={primaryColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </Icon>
  );
}
